export default function gatherEmail() {
  const form = document.getElementById("js_gather_email");
  function sendData() {
    const XHR = new XMLHttpRequest();

    // Bind the FormData object and the form element
    const FD = new FormData(form);
    const json = {
      href: window.location.href
    };
    FD.forEach((value, key) => { json[key] = value; });

    // Tell klaviyo about our user
    const _learnq = window._learnq || [];
    _learnq.push(['identify', {
      // email is required to identify
      $email: json.email,
      // date and url might be of interest in segmenting users
      date: new Date(),
      url: window.location.href
    }]);

    // TODO(matt) set up and point to a ramblemaps subdomain
    // Set up our request
    XHR.open("POST", "https://akmjl5zks0.execute-api.us-east-1.amazonaws.com/api/");
    XHR.setRequestHeader("content-type", "application/json");

    XHR.send(JSON.stringify(json));
    const onSubmit = document.getElementById("js_on_submit");
    document.getElementById('email').value = '';
    onSubmit.style.display = "block";
    onSubmit.innerHTML = "Sweet. Check your inbox!";
  }

  if (form) {
    // ...and take over its submit event.
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      sendData();

      window.pintrk('track', 'lead', {
        lead_type: 'Newsletter'
      });
      window.fbq('track', 'CompleteRegistration', {
        value: 0.0,
        currency: 'USD'
      });
      window.gtag("event", "submit", {
        event_category: "emailSubscribe",
      });
    });
  }
}
